import { Button, Typography, Box, Divider } from "@mui/material";

import ProfileSummary from "./profile/components/ProfileStatus";
import { useHistory } from "react-router-dom";

import GUIDELINES_PDF from "../../assets/internship-application-guidelines.pdf";

const sections = [
  {
    title: "Purpose",
    items: [
      "Improve employability and professional skills of graduates.",
      "Strengthen workplace learning across public, private, NGO, FBO, and academic institutions.",
      "Provide structured internships aligned with national priorities (NST2, Workplace Learning Policy, NESS).",
    ],
  },
  {
    title: "Program Structure",
    items: [
      "Internships last 6 months, extendable up to 12 months for priority fields.",
      "Program streams: NPIP, Community-Based Internships, Project-Based Internships, Special Academic Internships.",
    ],
  },
  {
    title: "Eligibility – Interns",
    items: [
      "Rwandan fresh graduates from HLIs or TVET A1+ (within 2 years of graduation).",
      "Refugee graduates with a valid refugee ID.",
      "International students in Rwanda (self-sponsored).",
      "Special Academic Internships: student in HLI/TVET, rare or specialized skills, aligned to NST2, internship agreement required.",
    ],
  },
  {
    title: "Eligibility – Host Institutions",
    items: [
      "Public institutions (including local government).",
      "Private sector, MSMEs, NGOs, FBOs, civil society, international organizations.",
      "Submit required documents and agree to supervision responsibilities.",
      "Special Academic Internships must provide at least 100,000 Rwf stipend.",
    ],
  },
  {
    title: "Application & Placement",
    items: [
      "Apply via the online portal; applications remain valid for 2 years.",
      "First-come-first-placed, with exceptions for special needs and recommendations.",
      "Private sector, NGOs, FBOs, districts, and public institutions outside Kigali may propose candidates.",
      "Hosts may interview candidates before confirming placements; induction is mandatory before internship starts.",
    ],
  },
  {
    title: "Financial Facilitation",
    items: [
      "Standard transport facilitation: 50,000 Rwf/month (paid by coordinating body or host).",
      "Extensions in priority fields are cost-shared; non-priority fields rely on host institutions.",
      "Host institutions cover all fieldwork costs.",
      "All arrears must be cleared before completion.",
    ],
  },
  {
    title: "Suspension & Completion",
    items: [
      "Default duration is 6 months; extensions require approval.",
      "Suspensions allowed for maternity, health issues, force majeure, or economic hardship.",
      "Completion requires a final report, performance evaluation, and certification.",
    ],
  },
  {
    title: "Young Professional Program (YPP)",
    items: [
      "Develops highly skilled graduates in critical or priority sectors.",
      "Targets young professionals with rare or specialized skills.",
      "Includes structured recruitment, placement, mentorship, evaluation, and a formal competency assessment.",
    ],
  },
];

const rolesAndResponsibilities = [
  {
    title: "Coordinating Institution",
    items: [
      "Assess host institutions and match interns.",
      "Provide transport facilitation.",
      "Monitor performance, address complaints, and issue completion certificates.",
    ],
  },
  {
    title: "Interns",
    items: [
      "Respect contracts, ethics, and workplace rules.",
      "Communicate challenges promptly and maintain professional conduct.",
      "Submit final reports and evaluations.",
    ],
  },
  {
    title: "Host Institutions",
    items: [
      "Sign contracts, assign mentors or supervisors, and provide a conducive workspace.",
      "Offer training opportunities and submit monthly and final performance reports.",
      "Cover fieldwork expenses and report misconduct, early exits, or conflicts.",
    ],
  },
];

export const InternshipApplicationGuidelinePage = (props) => {

  const history = useHistory();

  return (
    <div className="row mx-0 mt-4">
      <div className="col-12 col-sm-8 col-md-9 order-last order-sm-first mt-sm-0 px-1 px-sm-3">
        <section className="card mb-3 elevated rounded border border-primary bg-light">
          <div className="card-header bg-light rounded-top font-weight-bold ">
            <div className="my-1 d-flex flex-column flex-md-row justify-content-md-between align-items-center ">
              <Typography
                variant="h6"
                component="h2"
                className={`text-uppercase`}
                aria-labelledby="my-internship-application-list"
              >
                <span className="mr-2">NPIP & YPP Operational Guidelines</span>
              </Typography>

              <div className="d-flex flex-row align-items-center mt-2 justify-content-between">
                <Button
                  variant="text"
                  onClick={() => {
                    history.push("/applicant/internship-applications");
                  }}
                  className="mr-2"
                  aria-label="Back to Internship Applications"
                >
                  Back to Internship Applications
                </Button>
              </div>
            </div>
          </div>
          <div className="card-body" id="internship-application-guidelines">


            {sections.map((section) => (
              <Box key={section.title} className="mb-4">
                <Typography variant="h6" className="mb-2">
                  {section.title}
                </Typography>
                <ul className="pl-3 mb-0">
                  {section.items.map((item) => (
                    <li key={item} className="mb-1">
                      <Typography variant="body2">{item}</Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            ))}

            <Box className="mb-4">
              <Typography variant="h6" className="mb-2">
                Roles & Responsibilities
              </Typography>
              {rolesAndResponsibilities.map((role) => (
                <Box key={role.title} className="mb-3">
                  <Typography variant="subtitle1" className="mb-1">
                    {role.title}
                  </Typography>
                  <ul className="pl-3 mb-0">
                    {role.items.map((item) => (
                      <li key={item} className="mb-1">
                        <Typography variant="body2">{item}</Typography>
                      </li>
                    ))}
                  </ul>
                </Box>
              ))}
            </Box>
            <Box className="mt-4 mb-5 pb-5">
             
             {/* <Typography variant="subtitle1" color="text.secondary">
               March 2025
             </Typography> */}
             <Divider className="my-3" />
             <Typography variant="body2" className="mb-3">
               Download the complete document for reference or share with stakeholders.
             </Typography>
             <Button
               variant="text"
               color="primary"
               onClick={() => window.open(GUIDELINES_PDF, "_blank", "noopener")}
             >
               Download Full Guidelines (PDF)
             </Button>
           </Box>
          </div>
        </section>
      </div>
      <aside className="col-12 mb-3 col-sm-4 col-md-3 order-first order-sm-last px-1 px-sm-3">
        <ProfileSummary />
      </aside>
    </div>
  );
};

export default InternshipApplicationGuidelinePage;
